import { wrapFunctionalComponent } from 'utils/framework';
import localeUtils from 'utils/LanguageLocale';
import dateUtils from 'utils/Date';
import {
    Box, Text, Flex, Link
} from 'components/ui';
import Chevron from '../../../../Chevron';
import { colors } from 'style/config';
import PointActivityDetail from '../PointsActivityDetail/PointActivityDetail.f';

const getText = localeUtils.getLocaleResourceFile(
    'components/Content/BeautyInsider/BeautyInsiderModules/PointsActivityCard/locales',
    'PointsActivityCard'
);

const styles = {
    points: isPlus => `
        font-weight: bold;
        ${!isPlus ? `color: ${colors.gray}` : ''};
        margin-right: 10px;
        margin-left: auto;
    `,
    componentsWrap: `
        border-bottom: 1px solid ${colors.lightGray};
        margin-bottom: 16px;
        padding-bottom: 16px;
        &:last-child {
            border-bottom: none;
            margin-bottom: 0;
            padding-bottom: 0;
        }
    `,
    link: `
        color: ${colors.blue};
        text-decoration: underline;
    `,
    biStatusUpdatecontainer: `
        background-color: ${colors.nearWhite};
        padding: 8px;
        margin-top: 16px;
    `
};

const PointsActivityCard = ({ record, isExpanded, onToggle }) => {
    const isPlus = record.netGroupPoints > 0;

    return (
        <Box css={styles.componentsWrap}>
            <Box
                onClick={onToggle}
                width='100%'
                cursor='pointer'
            >
                <Flex alignItems='center'>
                    <Text fontWeight={'bold'}>{record.groupDescription}</Text>
                    <Text css={styles.points(isPlus)}>{`${isPlus ? '+' : ''}${record.netGroupPoints} pts`}</Text>
                    <Chevron
                        direction={isExpanded ? 'up' : 'down'}
                        size='10px'
                    />
                </Flex>
                <Text color={colors.gray}>{dateUtils.formatDateMDY(record.orderDate, true)}</Text>
            </Box>
            {isExpanded && (
                <Box marginTop={4}>
                    {record.digitalOrderId && (
                        <Text is='p'>
                            {`${getText('orderNumber')}: `}
                            {record.displayDigitalOrderIdAsLink ? (
                                <Link
                                    css={styles.link}
                                    href={`/profile/orderdetail/${record.digitalOrderId}`}
                                >
                                    {record.digitalOrderId}
                                </Link>
                            ) : (
                                record.digitalOrderId
                            )}
                        </Text>
                    )}
                    {record.pointActivities?.map((activity, index) => (
                        <PointActivityDetail
                            key={index}
                            activity={activity}
                        />
                    ))}
                    {record.tierRequalificationMessage && (
                        <Box css={styles.biStatusUpdatecontainer}>
                            <Text
                                is='p'
                                children={record.tierRequalificationMessage}
                            />
                        </Box>
                    )}
                </Box>
            )}
        </Box>
    );
};

export default wrapFunctionalComponent(PointsActivityCard, 'PointsActivityCard');
